<template>
	<div>
		<shifuUser v-if="identity == 2"></shifuUser>
		<yhUser v-else></yhUser>
	</div>
</template>

<script>
	import shifuUser from "./Shifu/user";
	import yhUser from "./User/user";
	import {
		indexOp,
		updateOp,
		deleteOp,
		addOp,
		showOp,
		uploadImg,
		uploadFile,
	} from "../api/index";
	import base from "../api/base";
	export default {
		components: {
			shifuUser,
			yhUser,
		},
		props: {},
		data() {
			return {
				identity: "0",
			};
		},
		computed: {},
		created() {
			this.identity = this.$cookies.get("identity");
			var userInfo = this.$cookies.get("userInfo");
			this.$cookies.set('identity',userInfo.identity);
			this.identity 	=	userInfo.identity;
		},
		mounted() {},
		watch: {},
		methods: {},
	};
</script>

<style scoped>
</style>
